/**
|--------------------------------------------------
| Menu redux reducers and action creators
|--------------------------------------------------
*/

/**
 * Initial state
 */
const initialState = {
  open: false
};

/**
  |--------------------------------------------------
  | Action types
  |--------------------------------------------------
  */
/**
 * Close menu action
 */
export const MENU_CLOSE = 'MENU_CLOSE';

/**
 * Open menu action
 */
export const MENU_OPEN = 'MENU_OPEN';

/**
 * Menu redux reducer
 */
export default (state = initialState, action) => {
  switch (action.type) {
    case MENU_OPEN:
      return {
        ...state,
        open: true
      };
    case MENU_CLOSE:
      return {
        ...state,
        open: false
      };
    default:
      return state;
  }
};

/**
  |--------------------------------------------------
  | Action creators
  |--------------------------------------------------
  */
/**
 * Open menu
 */
export const openMenu = () => ({
  type: MENU_OPEN
});

/**
 * Close menu
 */
export const closeMenu = () => ({
  type: MENU_CLOSE
});

/**
 * Set menu state
 * @param {boolean} open whether to set menu open or not
 */
export const setMenuState = open => {
  if (open) {
    return openMenu();
  }
  return closeMenu();
};

export const actionCreators = {
  openMenu,
  closeMenu
};
